import * as _pluginutils2 from "@rollup/pluginutils";

var _pluginutils = "default" in _pluginutils2 ? _pluginutils2.default : _pluginutils2;

var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var pluginutils = _pluginutils;

function json(options) {
  if (options === void 0) options = {};
  var filter = pluginutils.createFilter(options.include, options.exclude);
  var indent = "indent" in options ? options.indent : "\t";
  return {
    name: "json",
    // eslint-disable-next-line no-shadow
    transform: function transform(code, id) {
      if (id.slice(-5) !== ".json" || !filter(id)) {
        return null;
      }

      try {
        var parsed = JSON.parse(code);
        return {
          code: pluginutils.dataToEsm(parsed, {
            preferConst: options.preferConst,
            compact: options.compact,
            namedExports: options.namedExports,
            indent: indent
          }),
          map: {
            mappings: ""
          }
        };
      } catch (err) {
        var message = "Could not parse JSON file";
        var position = parseInt(/[\d]/.exec(err.message)[0], 10);
        this.warn({
          message: message,
          id: id,
          position: position
        });
        return null;
      }
    }
  };
}

exports.default = json;
exports = Object.assign(exports.default, exports); //# sourceMappingURL=index.js.map

export default exports;
export const __esModule = exports.__esModule;